import React from 'react';
import { isIOS, isMobile, isTablet } from 'react-device-detect';
import { useHistory } from 'react-router-dom';
import Store from 'store';
import { useHomePageContext } from '../../context/HomePageContext';
import { BannerBox } from '../HomePage';
import { getCurrentLang } from '../../libs/lang';
import { S3_URL } from '../../libs/common';

const isMobileView = isMobile;

export const TrendBanner = () => {
  const { state } = useHomePageContext();
  const history = useHistory();

  const goBannerUrl = (url, event) => {
    const urlRegex = /^(http|https):\/\//;
    if (event !== null) {
      history.push(`/events/view/${event}`);
    } else {
      if (urlRegex.test(url)) {
        window.open(url, '_blank');
      } else {
        history.push(url);
      }
    }
  };

  // 언어별 리스트 매핑
  const bannerMap = {
    kr: state.data.homeBannerListKo,
    en: state.data.homeBannerListEn,
    jp: state.data.homeBannerListJp,
  };

  const lang = getCurrentLang();
  const bannerList = bannerMap[lang] || [];

  const targetBanner = bannerList.find((x) => x.banner_type === 'home_1');
  if (!targetBanner) return null;

  // const imageUrl = isMobileView ? targetBanner.banner_mob_img : targetBanner.banner_img;
  const sizeCheck = window.innerWidth <= 500;
  const imageUrl = sizeCheck ? targetBanner.banner_mob_img : targetBanner.banner_img;

  return (
    <BannerBox
      style={{
        backgroundImage: `url(${S3_URL(imageUrl)})`,
        marginTop: '5vw',
        cursor: 'pointer',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        // marginLeft: '1px',
        // marginRight: '1px',
      }}
      onClick={() => goBannerUrl(targetBanner.banner_url, targetBanner.banner_event_id)}
    />
  );
};

export default TrendBanner;
